import { navigateTo } from 'gatsby-link'

function goToUrl(url) {
  return () => {
    if (/^http/.test(url)) {
      // eslint-disable-next-line
      return window.open(url, '_blank')
    }
    return navigateTo(url)
  }
}

export default goToUrl



// WEBPACK FOOTER //
// ./src/utils/goToUrl.js